import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcase24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSuitcase24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 4.5h2A1.5 1.5 0 0 1 14.5 6v1h-5V6A1.5 1.5 0 0 1 11 4.5M8 7V6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3zm8 1.5H8v4.2a1.5 1.5 0 0 1 0 2.6v4.2h8v-4.2a1.5 1.5 0 0 1 0-2.6zm1.5 6.8a1.5 1.5 0 0 0 0-2.6V8.5H19a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-1.5zm-11-6.8v4.2a1.5 1.5 0 0 0 0 2.6v4.2H5A1.5 1.5 0 0 1 3.5 18v-8A1.5 1.5 0 0 1 5 8.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcase24);
